var React = require('react');

function SVGIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","d":"M9.73549 10.2L15.4595 0.288C14.6195 0.108 13.7555 0 12.8555 0C9.9755 0 7.33549 1.02 5.27149 2.7L9.6635 10.32L9.73549 10.2ZM24.3034 8.40003C23.1994 4.89603 20.5234 2.08803 17.1034 0.792031L12.7114 8.40003H24.3034ZM24.6155 9.6H15.6275L15.9755 10.2L21.6875 20.1C23.6555 17.964 24.8555 15.132 24.8555 12C24.8555 11.172 24.7715 10.38 24.6155 9.6ZM8.70347 12L4.02347 3.9C2.06747 6.036 0.855469 8.868 0.855469 12C0.855469 12.828 0.939469 13.62 1.09547 14.4H10.0835L8.70347 12ZM1.40746 15.6C2.51146 19.104 5.18746 21.912 8.60746 23.208L12.9995 15.6H1.40746ZM14.9315 15.6L10.2515 23.712C11.0915 23.892 11.9555 24 12.8555 24C15.7355 24 18.3755 22.98 20.4395 21.3L16.0475 13.68L14.9315 15.6Z"}));
}

SVGIcon.defaultProps = {"viewBox":"0 0 25 24"};

module.exports = SVGIcon;

SVGIcon.default = SVGIcon;
